import React, { useEffect, useState } from "react";
import { dateMinMaxValidation } from "../../helpers/dateMinMaxValidation";
import { DatePicker } from "antd";
import moment from "moment";

export const FormDatePicker = ({
  selectedDate,
  onChange,
  getEvent,
  name,
  type,
  showTime,
  min,
  max,
  ...rest
}) => {
  const dateFormat =
    rest.format ?? (showTime ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD");
  const dateFormatHuman =
    rest.format ?? (showTime ? "DD-MM-YYYY HH:mm:ss" : "DD-MM-YYYY");

  const [InputValue, setValue] = useState(null);

  const handleChange = (date, dateString) => {
    if (!date) {
      setValue(null);
      if (onChange) {
        onChange(null);
      }

      if (getEvent) {
        const target = { name, value: null };
        getEvent({ target });
      }
    } else {
      const value = moment(date).format(dateFormat);
      setValue(value);
      if (onChange) {
        onChange(value);
      }

      if (getEvent) {
        const target = { name, value, date };
        getEvent({ target });
      }
    }
  };

  // data load on edit mode
  useEffect(() => {
    if (selectedDate) {
      if (moment(selectedDate, dateFormat, true).isValid()) {
        setValue(selectedDate);
      } else {
        setValue(moment(selectedDate).format(dateFormat));
      }
    } else {
      setValue(null);
    }
  }, [name, selectedDate]);

  // useEffect(() => {
  //   if (!value && onChange) {
  //     onChange(moment().format(dateFormat));
  //   }
  // }, []);

  return (
    <>
      <DatePicker
        showTime={showTime ?? false}
        picker={type ?? `date`}
        name={name || `date_field`}
        disabledDate={(current) =>
          rest?.disabledDate
            ? rest?.disabledDate(current)
            : dateMinMaxValidation(current, min, max)
        }
        value={InputValue ? moment(InputValue, dateFormat) : null}
        format={rest.format ?? dateFormatHuman}
        placeholder={rest.placeholder ?? dateFormat}
        onChange={handleChange}
        autoComplete="Off"
        readOnly={!!rest.readOnly}
        disabled={!!rest.disabled}
        id={rest.id || `_uid${Math.random() * 10}`}
        className={rest.input_class ?? `w-100`}
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
      />
    </>
  );
};
export default FormDatePicker;
